import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import { SyncLoader } from "react-spinners";
import ThemeConstants from "../../../../config/theme/theme_constants";
import { useTranslation } from "../../../../i18n/useTranslation";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

interface PdfPreviewProps {
  url: string;
}

const PdfPreview: React.FC<PdfPreviewProps> = ({ url }) => {
  const { t } = useTranslation();
  const theme = ThemeConstants();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) setWidth(entry.contentRect.width);
    });
    observer.observe(element);
    setWidth(element.clientWidth);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="w-full">
      <Document
        file={url}
        loading={
          <div className="aspect-4/3 flex items-center justify-center">
            <SyncLoader color={theme.UvibesPink} size={20} speedMultiplier={0.5} />
          </div>
        }
        error={
          <div className="aspect-4/3 flex items-center justify-center px-6 text-center">
            <span className="text-sm" style={{ color: theme.UvibesGray }}>
              {t('course.certificate.display_error')}
            </span>
          </div>
        }
      >
        {width > 0 && (
          <Page
            pageNumber={1}
            width={width}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        )}
      </Document>
    </div>
  );
};

export default PdfPreview;
